import logo from "../../images/VCallLogo.svg";
import { AppBar, Toolbar, Box, Button, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Link, NavigateFunction, useNavigate } from "react-router-dom";

const HeaderSignOut: React.FC = () => {
  const navigate: NavigateFunction = useNavigate();
  const [userName, setUserName] = useState<string>("");

  useEffect(() => {
    const storedUserName = sessionStorage.getItem("loginId");
    if (!storedUserName) {
      navigate("/signin");
    } else {
      setUserName(storedUserName);
    }
  }, [navigate]);

  const handleButtonClick = () => {
    sessionStorage.clear();
    navigate("/signin");
  };

  return (
    <AppBar position="static" style={{ backgroundColor: "#f6b602" }}>
      <Toolbar>
        <Box
          component={Link}
          to="/menu"
          sx={{ display: "inline-flex", alignItems: "center", mr: 2 }}
        >
          <Box component="img" src={logo} alt="Logo" sx={{ height: 30 }} />
        </Box>
        <Box sx={{ flexGrow: 1 }} />
        <Typography variant="body2" color="inherit" sx={{ mr: 1 }}>
          {userName}
        </Typography>
        <Typography variant="body2" color="inherit" sx={{ mx: 1 }}>
          |
        </Typography>
        <Button color="inherit" onClick={handleButtonClick}>
          サインアウト
        </Button>
      </Toolbar>
    </AppBar>
  );
};

export default HeaderSignOut;
